import { useTheme } from "@ihs-widget/stores/ThemeContext";
import { useEffect } from "react";
import shield_team_a from '@ihs-widget/assets/svg/statsConsoleAndOverview/shield_team_a.svg';
import shield_team_b from '@ihs-widget/assets/svg/statsConsoleAndOverview/shield_team_b.svg';
import shield_team_a_dark from '@ihs-widget/assets/svg/statsConsoleAndOverview/shield_team_a_dark.svg';
import shield_team_b_dark from '@ihs-widget/assets/svg/statsConsoleAndOverview/shield_team_b_dark.svg';
import DynamicShield from "../../common/StatsScoreboardTeam/DynamicShield/DynamicShield";
import { T } from "@ihs-widget/utils/enums";
import { useColorContext } from "@ihs-widget/stores/ColorContext";

type Iteam = 'team_a' | 'team_b' | 'team_a_dark' | 'team_b_dark';

interface IOverviewScoreboardTeamProps {
    team: Iteam;
    homeTeam: string | number;
    awayTeam: string | number;
}

const imageMap = {
    team_a: shield_team_a,
    team_b: shield_team_b,
    team_a_dark: shield_team_a_dark,
    team_b_dark: shield_team_b_dark
};

export const OverviewScoreboardTeamDynamic = ({ team, homeTeam, awayTeam }: IOverviewScoreboardTeamProps) => {
    const { theme } = useTheme();
    const shieldTeam = imageMap[team];
    const { colors, isDynamicColors } = useColorContext();

    return (
        <div data-testid={`stats-scoreboard-team-${team}`} className='w-full h-[44px] min-h-[44px] gap-[4px] flex flex-col justify-center items-center mt-[12px]'>
            <DynamicShield color={team.includes('team_a') ? colors?.homeColor : colors?.awayColor} />
            <div data-testid={`stats-scoreboard-team-name-${team}`} 
            className={`font-medium text-[12px] leading-[16px] text-monoY font-robotoMedium w-full 
            whitespace-nowrap text-ellipsis overflow-hidden
            [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]
            text-center`}>
                {team.includes('team_a') ? homeTeam : awayTeam}
            </div>
        </div>
    )
}
